import { z } from "zod";
import { NAME, KIT_TYPE } from "../consts";

export const schema = z.object({
  [NAME]: z.string().optional(),
  [KIT_TYPE]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
